export default function () {
  if (this.$route.name === 'EditTestimonial') {
    this.loadTestimonial()
  }
}
